export default __webpack_public_path__ + "static/media/LogoTrustPilot.2f7b51f2.svg";